// sapphire.js: v7 HAUTE COSMOS world. HOME: a sapphire Earth on a satin pillow in a vitrine, city lights set as pave diamonds.
// STUB: re-exports the v5 earth world so the site keeps working until the sapphire agent swaps in './sapphire/world.js'.
// Owner: the sapphire agent (see web/src/worlds/V7.md).
export { create } from './earth.js';
